import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { AppShell } from './components/AppShell';
import { Loading } from './components/Loading';
import { useAuth } from './context/AuthContext';
import { AdminPage } from './pages/AdminPage';
import { CreateTournamentPage } from './pages/CreateTournamentPage';
import { DashboardPage } from './pages/DashboardPage';
import { LoginPage } from './pages/LoginPage';
import { TournamentPage } from './pages/TournamentPage';

function Protected({ admin = false, children }: { admin?: boolean; children: React.ReactNode }) {
  const { user, loading } = useAuth();
  if (loading) return <Loading label="Restoring your session…" />;
  if (!user) return <Navigate to="/login" replace />;
  if (admin && user.role !== 'admin') return <Navigate to="/" replace />;
  return children;
}

export default function App() {
  return <BrowserRouter><Routes>
    <Route path="/login" element={<LoginPage />} />
    <Route element={<Protected><AppShell /></Protected>}>
      <Route index element={<DashboardPage />} />
      <Route path="tournaments/new" element={<CreateTournamentPage />} />
      <Route path="tournaments/:id" element={<TournamentPage />} />
      <Route path="admin" element={<Protected admin><AdminPage /></Protected>} />
    </Route>
    <Route path="*" element={<Navigate to="/" replace />} />
  </Routes></BrowserRouter>;
}

